import { difusionesConstants } from '../constants';

export const difusionesActions = {
    getDifusionesByAytoID:(data) => ({ type: difusionesConstants.GET_DIFUSIONES_AYTOID_REQUEST, data }),
}